import { isArray, isObject } from "underscore";
import Helper from "../../helper/Helper";
import store from "../../storeWire";

class documentResponseMaker {
    data = [];
    data_to_send = documentResponseMaker.defaultData();

    static defaultData = () => ({
        documentList: [],
        count: 0,
        facets: {
            DocumentType: {},
            FileFormat: {},
            Manufacturer: {},
        },
    });

    constructor(data, isAutoSearch) {
        this.data = data;
        this.isAutoSearch = isAutoSearch;
    }

    getTheKeyForThisAPIMaker = (key) => Helper.getTheKeyForThisAPIMaker(key);

    process = async () => {
        this.data_to_send = documentResponseMaker.defaultData();
        const state = store.getState();
        const documentContent_facets = { ...state.entities.model_HomePageContent?.documentContent?.facets };

        // Populate document list and count
        if (this.data?.data?.Documents) {
            this.data.data.Documents.forEach((v) => {
                v.DatePublishedObjectString = Helper.dateFormatFromString(v.DatePublished);
                this.data_to_send.documentList.push(v);
            });
        }
        this.data_to_send.count = this.data?.data?.Count || 0;

        // Process each facet category
        this.processFacetCategory("DocumentType", documentContent_facets);
        this.processFacetCategory("FileFormat", documentContent_facets);
        this.processFacetCategory("Manufacturer", documentContent_facets);

        return this;
    };

    processFacetCategory = (category, documentContent_facets) => {
        if (isObject(documentContent_facets[category])) {
            Object.entries(documentContent_facets[category]).forEach(([key, value]) => {
                const item = { ...value, disabled: !(key in this.data_to_send.facets[category]) };
                this.data_to_send.facets[category][key] = item;
            });
        }

        if (isArray(this.data?.data?.[category])) {
            this.data.data[category].forEach((v) => {
                const slug = this.getTheKeyForThisAPIMaker(v.Name);
                this.data_to_send.facets[category][slug] = { ...v, slug, disabled: false };
            });
        }
    };

    run = () => this;

    get = () => ({ data: this.data_to_send });
}

export default documentResponseMaker